export * from './app-sidebar-form.component';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/components/app-sidebar-form/index.ts